import React from 'react';
import styled from 'styled-components';
import { Tabs as TabsBootstrap, Tab as TabBoostrap } from 'react-bootstrap';

import type { ITab } from '@/components/common/types';

const Tab = ({
  children,
  activeKey,
  onSelect,
  className,
  mountOnEnter,
  defaultActiveKey,
}: ITab): React.ReactElement => (
  <StyledTabs
    mountOnEnter={mountOnEnter}
    activeKey={activeKey}
    onSelect={onSelect}
    className={className}
    defaultActiveKey={defaultActiveKey}
    transition={false}
  >
    {children}
  </StyledTabs>
);

Tab.Item = TabBoostrap;

export { Tab };

const StyledTabs = styled(TabsBootstrap)`
  margin-bottom: 1rem;

  .nav-link {
    padding: 0.5rem !important;
    text-decoration: none;
    white-space: nowrap;
    font-size: 16px;
    line-height: 24px;
    color: #5a5a5a;
    border-radius: 8px 8px 0 0 !important;
    font-family: barlow;

    &.active {
      color: #0087dd !important;
    }
  }

  &.nav-tabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
  }

  ::-webkit-scrollbar {
    height: 4px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    margin-top: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  }
`;
